import React from "react";
import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { PasswordInput } from "@ebsco-ui/ebsco-ui";
import messages from "../../../../../shared-messages";

import "./password-input-field.scss";

const PasswordInputField = ({ validationSchema, name, id, ...rest }) => {
  const { formatMessage } = useIntl();
  const validateWithSchema = (value, allFormValues) => {
    if (validationSchema) {
      try {
        validationSchema.validateSync({ value, allFormValues });
      } catch (error) {
        return error.message;
      }
    }
  };

  const errorToDisplay = meta => {
    if (meta.error && meta.submitFailed) return meta.error;
    if (meta.submitError && !meta.dirtySinceLastSubmit) return meta.submitError;
    return "";
  };

  return (
    <Field name={name} initialValue="" id={id} validate={validateWithSchema}>
      {({ input, meta }) => (
        <PasswordInput
          className="password-input-field"
          showPasswordButtonText={formatMessage(messages.show)}
          hidePasswordButtonText={formatMessage(messages.hide)}
          error={errorToDisplay(meta)}
          id={id}
          {...input}
          {...rest}
        />
      )}
    </Field>
  );
};

PasswordInputField.propTypes = {
  name: PropTypes.string.isRequired,
  validationSchema: PropTypes.object
};

export default PasswordInputField;
